export default {
    failedRecording: {
        hide: 'Hide for this visit',
        hideLabel: 'Hide failed recording {name} for this visit',
        showHidden: 'Show hidden failed recordings ({count})',
    },
    // C
    capture: 'Capture',
    chooseAnImage: 'Choose an image from your video or upload from your device.',
    coverCaptureUnavailable: 'Capturing a frame is not available for this video. Upload an image to set the cover instead.',
    coverEditorLoading: 'Opening cover editor...',
    customizeThumbnail: 'Customize thumbnail',

    // D
    duplicateFailed: 'The copy could not be created',
    duplicateLatestVersion: 'Latest version',
    duplicateLatestVersionText: 'Your copy will start from the most recent edited version, and keeps the link to the source project files.',
    duplicateMedia: 'Duplicate Media',
    duplicateOriginalMedia: 'Original media',
    duplicateOriginalMediaText: 'Your copy will start from the original media, before any edits.',
    duplicateWhichVersion: 'Which version do you want to duplicate?',
    duplicating: 'Duplicating…',
    duplicatedTitle: 'Copy created',
    duplicatedText: 'Opening your new copy.',

    // P
    playYourVideo: 'Play your video and pause it at the frame you wish to use as the cover image. Click on the "Capture" button to save the preview image.',

    // S
    saveImage: 'Save image',
}
